import { render, staticRenderFns } from "./OtpVerificationPopup.vue?vue&type=template&id=5d2350d6&"
import script from "./OtpVerificationPopup.vue?vue&type=script&lang=js&"
export * from "./OtpVerificationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports